export const convertToSubUnit = (amount) => {
  return amount * 100;
};
